// extracted by mini-css-extract-plugin
export default {"capture":"styles_capture__CxVZ9","heading":"styles_heading__FcXB5","captureBody":"styles_captureBody__5JMgf"};